import React from 'react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      quote: "We now have a fully automated Service Catalogue. This has delivered time-saving, cost control, improved customer experience, and a predictable service management model.",
      author: "IT Director",
      company: "Koç Holding",
      avatar: 'https://public.readdy.ai/ai/img_res/b0637798c8c983a98e19bf66f1839f73.jpg'
    },
    {
      quote: "Autom Mate has transformed our IT operations. The zero-touch automation capabilities have reduced our incident response time by 80% and significantly improved our service quality.",
      author: "CTO",
      company: "Vodafone",
      avatar: 'https://readdy.ai/api/search-image?query=technology%20executive%20portrait%2C%20CTO%20in%20modern%20tech%20office%2C%20professional%20business%20headshot%20with%20confident%20expression&width=80&height=80&seq=testimonial2&orientation=squarish'
    },
    {
      quote: "The AI Agent Composer has revolutionized how we handle customer requests. Our team can now focus on strategic initiatives while automation handles routine tasks seamlessly.",
      author: "Operations Manager",
      company: "Mitsubishi",
      avatar: 'https://readdy.ai/api/search-image?query=operations%20manager%20portrait%2C%20professional%20business%20woman%20in%20corporate%20environment%2C%20confident%20leadership%20headshot&width=80&height=80&seq=testimonial3&orientation=squarish'
    }
  ];

  const logos = [
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-HDI-cl.png',
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-Mitsubishi-cl.png',
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-Vodafone-cl.png',
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-suzuki-cl.png',
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-Koc-cl.png',
    'https://www.autommate.com/wp-content/uploads/2025/09/customer-OTC-CL.png'
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join thousands of organizations worldwide who trust Autom Mate for their automation needs.
          </p>
        </div>

        {/* Customer Logos */}
        <div className="mb-16">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center opacity-60">
            {logos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center">
                <img 
                  src={logo} 
                  alt={`Customer ${index + 1}`}
                  className="h-12 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="mb-6">
                <i className="ri-double-quotes-l text-4xl text-blue-600 opacity-50"></i>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center">
                <img 
                  src={testimonial.avatar} 
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.author}</h4>
                  <p className="text-gray-600">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;